import { ProductTab } from './ProductTab'

export default ProductTab
